/* Florida Plants Nursery — AI chat widget
 * Upload to your theme as assets/fpn-chat.js and load it with snippets/fpn-ai-chat.liquid.
 * Settings come from window.FPN_CHAT_CONFIG (set in the snippet).
 * If "endpoint" is empty the widget runs in preview mode with canned replies.
 */
(function () {
  if (window.__fpnChatLoaded) return;
  window.__fpnChatLoaded = true;

  var C = Object.assign({
    endpoint: "",
    storeName: "Florida Plants Nursery",
    currency: "USD",
    greeting: "Hi! I can help you pick the right plant for your yard or home, check what's in stock, or answer care questions. What are you shopping for?",
    teaser: "Not sure which plant fits your space? Ask me.",
    teaserDelayMs: 20000,
    autoOpenMs: 0,            // open the chat window by itself after this many ms (0 = never)
    autoOpenMobile: false,    // on phones the window is full-screen, so auto-open is off by default
    suggestions: ["What grows well in a pot?", "Something easy for a beginner", "Which banana tree should I get?"],
    side: "right"
  }, window.FPN_CHAT_CONFIG || {});

  var KEY = "fpn_chat_v1";
  var FLAG_TEASER = "fpn_chat_teaser_seen";
  var FLAG_AUTO = "fpn_chat_auto_done";
  var state = load() || { messages: [] };
  if (!state.cid) state.cid = newId();   // one ID per conversation, used for chat history
  var busy = false;

  // ─── DOM ──────────────────────────────────────────────────────────────────
  // Custom tag + forced display: some themes (Dawn family) hide "empty" divs, and
  // a shadow-DOM host looks empty to page CSS.
  var host = document.createElement("fpn-chat-root");
  host.id = "fpn-chat";
  host.style.setProperty("display", "block", "important");
  document.body.appendChild(host);
  var root = host.attachShadow({ mode: "open" });

  root.innerHTML =
    '<style>' + css() + '</style>' +
    '<div class="wrap side-' + (C.side === "left" || C.side === "center" ? C.side : "right") + '">' +
      '<div class="teaser" hidden>' +
        '<button class="teaser-open" type="button"></button>' +
        '<button class="teaser-x" type="button" aria-label="Dismiss">' + icon("x", 14) + '</button>' +
      '</div>' +
      '<section class="panel" role="dialog" aria-modal="false" aria-label="Chat with ' + esc(C.storeName) + '" hidden>' +
        '<header>' +
          '<div class="who"><span class="mark" aria-hidden="true">' + icon("leaf", 18) + '</span>' +
            '<div><strong>' + esc(C.storeName) + '</strong><span>AI plant helper, replies in seconds</span></div></div>' +
          '<button class="close" type="button" aria-label="Close chat">' + icon("x", 18) + '</button>' +
        '</header>' +
        '<div class="log" aria-live="polite"></div>' +
        '<div class="chips"></div>' +
        '<form class="composer">' +
          '<textarea rows="1" maxlength="1500" placeholder="Ask about a plant…" aria-label="Your message"></textarea>' +
          '<button class="send" type="submit" aria-label="Send">' + icon("send", 18) + '</button>' +
        '</form>' +
        '<p class="fine">AI answers can be wrong. Chats are saved to help us improve.</p>' +
      '</section>' +
      '<button class="launcher" type="button" aria-label="Chat with us" aria-expanded="false">' +
        '<span class="i-open">' + icon("chat", 26) + '</span><span class="i-close">' + icon("x", 24) + '</span>' +
        '<span class="dot" hidden></span>' +
      '</button>' +
    '</div>';

  var $ = function (s) { return root.querySelector(s); };
  var panel = $(".panel"), log = $(".log"), chips = $(".chips"), form = $(".composer"),
      input = $("textarea"), sendBtn = $(".send"), launcher = $(".launcher"),
      teaser = $(".teaser"), dot = $(".dot");

  $(".teaser-open").textContent = C.teaser;

  launcher.addEventListener("click", function () { panel.hidden ? open() : close(); });
  $(".close").addEventListener("click", close);
  $(".teaser-open").addEventListener("click", open);
  $(".teaser-x").addEventListener("click", function () { hideTeaser(); session(FLAG_AUTO, "1"); });
  root.addEventListener("keydown", function (e) { if (e.key === "Escape" && !panel.hidden) close(); });

  input.addEventListener("input", grow);
  input.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); form.requestSubmit ? form.requestSubmit() : submit(e); }
  });
  form.addEventListener("submit", submit);

  renderAll();

  // Proactive pop-up: once per browsing session, after a delay, if chat wasn't opened.
  if (!session(FLAG_TEASER) && state.messages.length === 0) {
    setTimeout(function () {
      if (!panel.hidden || session(FLAG_TEASER)) return;
      teaser.hidden = false; dot.hidden = false;
      session(FLAG_TEASER, "1");
      track("fpn_chat_teaser_shown");
    }, C.teaserDelayMs);
  }

  // Auto-open: once per browsing session, desktop only unless enabled for mobile,
  // skipped if the shopper already chatted or dismissed the pop-up message.
  if (C.autoOpenMs && !session(FLAG_AUTO) && state.messages.length === 0 &&
      (C.autoOpenMobile || window.matchMedia("(min-width: 768px)").matches)) {
    setTimeout(function () {
      if (!panel.hidden || session(FLAG_AUTO)) return;
      session(FLAG_AUTO, "1");
      open(true);
    }, C.autoOpenMs);
  }

  // ─── Behaviour ────────────────────────────────────────────────────────────
  function open(auto) {
    auto = auto === true;
    hideTeaser();
    session(FLAG_AUTO, "1");
    panel.hidden = false;
    launcher.setAttribute("aria-expanded", "true");
    host.classList.add("is-open");
    root.querySelector(".wrap").classList.add("open");
    scrollDown();
    if (!auto) setTimeout(function () { input.focus(); }, 60);
    track(auto ? "fpn_chat_auto_opened" : "fpn_chat_opened");
  }
  function close() {
    panel.hidden = true;
    launcher.setAttribute("aria-expanded", "false");
    root.querySelector(".wrap").classList.remove("open");
    launcher.focus();
  }
  function hideTeaser() { teaser.hidden = true; dot.hidden = true; session(FLAG_TEASER, "1"); }

  function submit(e) {
    if (e) e.preventDefault();
    var text = input.value.trim();
    if (!text || busy) return;
    input.value = ""; grow();
    ask(text);
  }

  function ask(text) {
    state.messages.push({ role: "user", content: text });
    save(); renderAll();
    track("fpn_chat_message_sent");
    setBusy(true);

    var typing = el("div", "msg bot typing", '<span></span><span></span><span></span>');
    log.appendChild(typing); scrollDown();

    request().then(function (res) {
      var blocks = res.blocks || [];
      if (!blocks.length) throw new Error("empty reply");
      state.messages.push({ role: "assistant", blocks: blocks });
    }).catch(function () {
      state.messages.push({ role: "assistant", error: true,
        content: "I couldn't connect just now. Please try again in a moment, or reach us through the contact page." });
    }).then(function () {
      // Show the START of the new reply, so the shopper reads it top to bottom.
      typing.remove(); save(); renderAll(true); setBusy(false); input.focus();
    });
  }

  function request() {
    if (!C.endpoint) return preview();
    // Rebuild each assistant turn with its [[product:...]] tokens so the AI remembers what it showed.
    var history = state.messages.filter(function (m) { return !m.error; }).map(function (m) {
      if (!m.blocks) return { role: m.role, content: m.content };
      return { role: m.role, content: m.blocks.map(function (b) {
        return b.type === "product" ? "[[product:" + b.product.handle + "]]" : b.text;
      }).join("\n") };
    });
    var ctrl = window.AbortController ? new AbortController() : null;
    var t = setTimeout(function () { ctrl && ctrl.abort(); }, 30000);
    return fetch(C.endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ conversationId: state.cid, messages: history, page: { path: location.pathname, title: document.title } }),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) {
      clearTimeout(t);
      if (!r.ok) throw new Error("HTTP " + r.status);
      return r.json();
    });
  }

  function preview() {
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve({ blocks: [
          { type: "text", text: "This is a preview with sample products. Once connected, I'll answer from your live catalog. A dwarf variety is the right call for a pot. Here are the two I'd look at:" },
          { type: "text", text: "**Dwarf banana tree (sample)** is the most compact option and the easiest to roll indoors on cold nights." },
          { type: "product", product: { handle: "sample-1", title: "Dwarf banana tree (sample)", url: "#", price: "0",
            priceFrom: null, image: null, variantId: 1, hasOptions: false, available: true } },
          { type: "text", text: "**Second banana pick (sample)** grows a bit taller. Pick it if you want a bigger tropical look." },
          { type: "product", product: { handle: "sample-2", title: "Second banana pick (sample)", url: "#", price: "0",
            priceFrom: "0", image: null, variantId: 2, hasOptions: true, available: true } }
        ] });
      }, 900);
    });
  }

  function addToCart(p, btn) {
    btn.disabled = true; btn.textContent = "Adding…";
    if (!C.endpoint) { setTimeout(function () { added(btn); }, 500); return; }
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: p.variantId, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error();
      added(btn);
      track("fpn_chat_add_to_cart", { title: p.title, variant_id: p.variantId });
      report({ type: "add_to_cart", title: p.title });
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    }).catch(function () {
      btn.disabled = false; btn.textContent = "Try again";
    });
  }
  function added(btn) {
    var a = el("a", "btn ghost", "Added. View cart");
    a.href = "/cart";
    btn.replaceWith(a);
  }

  // ─── Rendering ────────────────────────────────────────────────────────────
  function renderAll(anchorReply) {
    log.innerHTML = "";
    log.appendChild(el("div", "msg bot", format(C.greeting)));
    var replyStart = null;
    var lastIndex = state.messages.length - 1;
    state.messages.forEach(function (m, i) {
      var before = log.lastChild;
      if (m.blocks) {
        // Keep the AI's order: write-up, then that plant's card, then the next plant.
        m.blocks.forEach(function (b) {
          if (b.type === "product") log.appendChild(card(b.product));
          else if (b.text) log.appendChild(el("div", "msg bot", format(b.text)));
        });
      } else if (m.content) {
        log.appendChild(el("div", "msg " + (m.role === "user" ? "me" : "bot") + (m.error ? " err" : ""), format(m.content)));
      }
      if (i === lastIndex && m.role === "assistant") replyStart = before ? before.nextSibling : log.firstChild;
    });
    chips.innerHTML = "";
    chips.hidden = state.messages.length > 0;
    if (!chips.hidden) C.suggestions.forEach(function (s) {
      var b = el("button", "chip", esc(s)); b.type = "button";
      b.addEventListener("click", function () { ask(s); });
      chips.appendChild(b);
    });
    if (anchorReply && replyStart) scrollToEl(replyStart);
    else scrollDown();
  }

  function card(p) {
      var img = p.image ? '<img src="' + esc(sized(p.image)) + '" alt="" width="64" height="64" loading="lazy">'
                        : '<span class="noimg" aria-hidden="true">' + icon("leaf", 24) + '</span>';
      var price = p.priceFrom ? "From " + fmt(p.priceFrom) : fmt(p.price);
      var card = el("div", "card",
        img +
        '<div class="meta"><a class="title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<span class="price">' + (p.available ? esc(price) : "Sold out") + '</span>' +
        (p.collection ? '<a class="coll" href="' + esc(p.collection.url) + '">See more in ' + esc(p.collection.title) + '</a>' : '') +
        '</div>');
      var action;
      if (!p.available) {
        action = el("a", "btn ghost", "View"); action.href = p.url;
      } else if (p.hasOptions) {
        action = el("a", "btn", "Choose size"); action.href = p.url;
      } else {
        action = el("button", "btn", "Add to cart"); action.type = "button";
        action.addEventListener("click", function () { addToCart(p, action); });
      }
      card.appendChild(action);
      return card;
  }

  // Safe mini-markdown: escape first, then **bold**, [text](/relative-or-same-site), line breaks.
  function format(text) {
    var s = esc(text);
    s = s.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
    s = s.replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, function (_, label, url) {
      var ok = url.charAt(0) === "/" || url.indexOf(location.origin) === 0;
      return ok ? '<a href="' + url + '">' + label + "</a>" : label;
    });
    return s.replace(/\n/g, "<br>");
  }

  // Tell the backend about an Add to cart from the chat (for the history page).
  function report(ev) {
    if (!C.endpoint) return;
    try {
      ev.conversationId = state.cid;
      fetch(C.endpoint.replace(/\/+$/, "") + "/event", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify(ev), keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }
  function newId() {
    try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
    return "c" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 12);
  }

  function setBusy(b) { busy = b; sendBtn.disabled = b; }
  function grow() { input.style.height = "auto"; input.style.height = Math.min(input.scrollHeight, 120) + "px"; }
  function scrollDown() { requestAnimationFrame(function () { log.scrollTop = log.scrollHeight; }); }
  function scrollToEl(node) { requestAnimationFrame(function () { log.scrollTop = Math.max(0, node.offsetTop - 12); }); }

  // ─── Helpers ──────────────────────────────────────────────────────────────
  function el(tag, cls, html) { var n = document.createElement(tag); n.className = cls; n.innerHTML = html; return n; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function fmt(v) {
    var n = parseFloat(v); if (isNaN(n)) return "";
    try { return new Intl.NumberFormat(undefined, { style: "currency", currency: C.currency }).format(n); }
    catch (e) { return "$" + n.toFixed(2); }
  }
  function sized(src) { return src + (src.indexOf("?") > -1 ? "&" : "?") + "width=160"; }
  function load() { try { return JSON.parse(sessionStorage.getItem(KEY)); } catch (e) { return null; } }
  function save() {
    try { state.messages = state.messages.slice(-30); sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
  }
  function session(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; }
  }
  // Shows up in Shopify Customer Events (custom pixels) so you can measure chat → purchase.
  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {}
  }

  function icon(name, size) {
    var p = {
      chat: '<path d="M4 5.5A2.5 2.5 0 0 1 6.5 3h11A2.5 2.5 0 0 1 20 5.5v8a2.5 2.5 0 0 1-2.5 2.5H10l-4.2 3.6c-.5.4-1.3.1-1.3-.6V16A2.5 2.5 0 0 1 4 13.5z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M8.5 9.5h7M8.5 12.5h4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>',
      x: '<path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>',
      send: '<path d="M4 12l16-8-6 16-2.5-6.5z" fill="currentColor"/>',
      leaf: '<path d="M5 19C5 10 10 5 20 4c-1 10-6 15-15 15z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M5 19l9-9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>'
    }[name];
    return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" aria-hidden="true">' + p + "</svg>";
  }

  function css() { return "\
:host{all:initial}\
.wrap{--canopy:#173F2F;--leaf:#2E7D4F;--leaf-dark:#246540;--mist:#F1F5EE;--line:#D9E3D5;--ink:#1C2420;--soft:#5B6B62;--mango:#F4A62A;\
position:fixed;bottom:20px;z-index:2147483000;font-family:var(--font-body-family,system-ui,-apple-system,'Segoe UI',sans-serif);color:var(--ink);font-size:15px;line-height:1.45;-webkit-font-smoothing:antialiased}\
.side-right{right:20px}.side-left{left:20px}\
.side-center{left:0;right:0;display:flex;justify-content:center;pointer-events:none}\
.side-center>*{pointer-events:auto}\
*{box-sizing:border-box}\
button,textarea{font:inherit;color:inherit}\
.launcher{position:relative;width:60px;height:60px;border:0;cursor:pointer;display:grid;place-items:center;color:#fff;background:var(--leaf);\
border-radius:6px 60% 6px 60%;box-shadow:0 10px 26px rgba(23,63,47,.32);transition:border-radius .3s ease,background .2s ease,transform .2s ease}\
.side-left .launcher{border-radius:60% 6px 60% 6px}\
.launcher:hover{background:var(--leaf-dark);transform:translateY(-2px)}\
.open .launcher{border-radius:50%}\
.launcher .i-close,.open .launcher .i-open{display:none}.open .launcher .i-close{display:block}\
.launcher svg{display:block}\
.dot{position:absolute;top:4px;right:4px;width:12px;height:12px;border-radius:50%;background:var(--mango);border:2px solid #fff}\
.teaser{position:absolute;bottom:74px;width:250px;background:#fff;border:1px solid var(--line);border-radius:14px;box-shadow:0 10px 30px rgba(23,63,47,.18);\
animation:rise .35s ease both}\
.side-right .teaser{right:0}.side-left .teaser{left:0}.side-center .teaser{left:0;right:0;margin:0 auto}\
.teaser-open{display:block;width:100%;text-align:left;background:none;border:0;padding:14px 34px 14px 16px;cursor:pointer;font-size:14.5px;line-height:1.4}\
.teaser-x{position:absolute;top:6px;right:6px;width:26px;height:26px;border:0;border-radius:50%;background:transparent;cursor:pointer;color:var(--soft);display:grid;place-items:center}\
.teaser-x:hover{background:var(--mist)}\
.panel{position:absolute;bottom:76px;width:380px;height:min(600px,calc(100vh - 120px));display:flex;flex-direction:column;background:var(--mist);\
border-radius:18px;overflow:hidden;box-shadow:0 18px 50px rgba(23,63,47,.28);animation:pop .22s ease both}\
.side-right .panel{right:0;transform-origin:bottom right}.side-left .panel{left:0;transform-origin:bottom left}\
.side-center .panel{left:0;right:0;margin:0 auto;transform-origin:bottom center}\
.panel[hidden],.teaser[hidden],.dot[hidden],.chips[hidden]{display:none}\
header{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:14px 12px 14px 16px;background:var(--canopy);color:#fff}\
.who{display:flex;align-items:center;gap:10px;min-width:0}\
.who strong{display:block;font-family:var(--font-heading-family,inherit);font-size:16px;font-weight:600;letter-spacing:.01em}\
.who span:not(.mark){display:block;font-size:12.5px;opacity:.78}\
.mark{width:34px;height:34px;flex:none;border-radius:4px 50% 4px 50%;background:rgba(255,255,255,.14);display:grid;place-items:center}\
.close{width:34px;height:34px;border:0;border-radius:50%;background:transparent;color:#fff;cursor:pointer;display:grid;place-items:center}\
.close:hover{background:rgba(255,255,255,.14)}\
.log{position:relative;flex:1;overflow-y:auto;padding:16px 14px 8px;display:flex;flex-direction:column;gap:8px;overscroll-behavior:contain}\
.msg{max-width:86%;padding:10px 13px;border-radius:14px;word-wrap:break-word;font-size:14.5px}\
.msg a{color:inherit;text-decoration:underline;text-underline-offset:2px}\
.bot{align-self:flex-start;background:#fff;border:1px solid var(--line);border-bottom-left-radius:4px}\
.me{align-self:flex-end;background:var(--leaf);color:#fff;border-bottom-right-radius:4px}\
.err{border-color:#E7C9A3;background:#FFF8EE}\
.typing{display:flex;gap:4px;padding:14px}\
.typing span{width:7px;height:7px;border-radius:50%;background:var(--soft);opacity:.4;animation:blink 1.2s infinite}\
.typing span:nth-child(2){animation-delay:.2s}.typing span:nth-child(3){animation-delay:.4s}\
.card{align-self:stretch;margin:-2px 0 6px;display:grid;grid-template-columns:64px 1fr auto;align-items:center;gap:10px;background:#fff;border:1px solid var(--line);border-radius:12px;padding:8px}\
.card img,.noimg{width:64px;height:64px;border-radius:8px;object-fit:cover;background:var(--mist)}\
.noimg{display:grid;place-items:center;color:var(--leaf)}\
.meta{min-width:0}\
.title{display:block;color:var(--ink);font-weight:600;font-size:14px;line-height:1.3;text-decoration:none;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}\
.title:hover{text-decoration:underline}\
.price{display:block;font-size:13.5px;color:var(--soft);margin-top:2px}\
.coll{display:block;margin-top:3px;font-size:12.5px;color:var(--leaf-dark);text-decoration:underline;text-underline-offset:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}\
.coll:hover{color:var(--canopy)}\
.btn{border:0;border-radius:999px;background:var(--leaf);color:#fff;padding:8px 12px;font-size:13px;font-weight:600;cursor:pointer;text-decoration:none;white-space:nowrap}\
.btn:hover{background:var(--leaf-dark)}\
.btn:disabled{opacity:.6;cursor:default}\
.btn.ghost{background:transparent;color:var(--leaf);box-shadow:inset 0 0 0 1.5px var(--leaf)}\
.chips{display:flex;flex-wrap:wrap;gap:6px;padding:4px 14px 10px}\
.chip{border:1.5px solid var(--leaf);background:#fff;color:var(--leaf-dark);border-radius:999px;padding:6px 12px;font-size:13.5px;cursor:pointer}\
.chip:hover{background:var(--leaf);color:#fff}\
.composer{display:flex;align-items:flex-end;gap:8px;margin:0 10px;padding:8px 8px 8px 14px;background:#fff;border:1px solid var(--line);border-radius:16px}\
.composer:focus-within{border-color:var(--leaf)}\
textarea{flex:1;border:0;outline:0;resize:none;background:transparent;font-size:15px;line-height:1.4;padding:6px 0;max-height:120px}\
.send{width:38px;height:38px;flex:none;border:0;border-radius:50%;background:var(--leaf);color:#fff;cursor:pointer;display:grid;place-items:center}\
.send:disabled{opacity:.5;cursor:default}\
.fine{margin:6px 0 10px;text-align:center;font-size:11.5px;color:var(--soft)}\
button:focus-visible,a:focus-visible{outline:2px solid var(--mango);outline-offset:2px}\
@keyframes pop{from{opacity:0;transform:scale(.94)}to{opacity:1;transform:scale(1)}}\
@keyframes rise{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}\
@keyframes blink{0%,80%,100%{opacity:.25}40%{opacity:.9}}\
@media (prefers-reduced-motion:reduce){*{animation:none!important;transition:none!important}}\
@media (max-width:480px){\
.wrap{bottom:14px}.side-right{right:14px}.side-left{left:14px}\
.open .side-center .panel,.side-center.open .panel{margin:0}\
.open .panel{position:fixed;inset:0;width:100%;height:100%;height:100dvh;border-radius:0;padding-bottom:env(safe-area-inset-bottom)}\
.open .launcher{display:none}\
header{padding-top:calc(14px + env(safe-area-inset-top))}\
.teaser{width:min(250px,calc(100vw - 28px))}\
textarea{font-size:16px}}\
"; }
})();
